import { Component, OnInit } from '@angular/core';
import { SharedService } from '@app/ts/services/SharedService';
import { LayoutService } from '@app/shared/layout/layout.service';
import { CommonService } from "@app/shared/common/common.service";
import { I18nService } from '@app/shared/i18n/i18n.service';
// import * as jwt from "jsonwebtoken";
declare var $: any;

@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html'
})

export class FooterComponent implements OnInit {
  year;
  decodeOptions: {};
  showDevOptions:boolean = false;
  devOptionsRight:boolean = false;
  public state: any = {
    tabs: {
      demo1: 0
    }
  }

  constructor(public layoutService: LayoutService, public commonService: CommonService, public i18nService: I18nService, private sharedService: SharedService) {
	var self = this;
    $(document).off('click', ".showDownloadCenter").on('click', ".showDownloadCenter", function () {
      self.sharedService.getExportRequest(true);
      $(".showDownloadCenter").css("background-color", "#0c7cd5");
    });
    // let rights = JSON.parse(this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.userRights)))).userRights;
    // let rightsArray = rights.split(',') 
    // this.devOptionsRight = rightsArray.includes('ngtDevOpt') ;  
  }

  ngOnInit() {
    let date = new Date();
    this.year = date.getFullYear();
    // this.initDecodePopup();
  }
  
  factoryReset() { 
    this.layoutService.factoryReset();
  }

  // initDecodePopup() {
  //   var header = this.i18nService.getTranslation("common_all_decode");
  //   this.decodeOptions = {
  //     autoOpen: false,
  //     modal: true,
  //     width: window.innerWidth > 767 ? '40%' : '100%',
  //     resizable: false,
  //     closeText: '',
  //     title: "<div class='widget-header'><h4><i class='fa fa-code-fork'></i> &nbsp;" + header + "</h4></div>",
  //     open: ()=>{
  //       // this.userDecode = {
  //       //   note: '',
  //       //   decode: '{}'
  //       // };
  //       $(".disableResult textarea").attr("disabled",true);
  //     },
  //     close: ()=>{
  //       // this.closeDecode();
  //       $('#encrypted').val('');
  //       $('#decrypted').val('');
  //     }
  //   };
  //   $("#decodepopup").dialog(this.decodeOptions);
  // }

  clear() {
    $('#encrypted').val('');
    $('#decrypted').val('');
  }

  decode() {
    let errorVal = '';
    let decryptedToken;
    // if($('#encrypted').val()!='') {
    //   try{
    //     decryptedToken = this.commonService.decrypt($('#encrypted').val())
    //   }
    //   catch(Error){
    //     errorVal = "Not a valid Token";
    //   }
    //   if(errorVal==''){
    //     $('#decrypted').val(JSON.stringify(jwt.decode(decryptedToken), null, 2))
    //   }
    //   else{
    //     $('#encrypted').val(errorVal);
    //   }

    // }
  }

  ngOnDestroy() {
    // $('#decodepopup').dialog("destroy");
  }

  openDevOption() {
    // $('#decodepopup').dialog("open");
    this.showDevOptions = !this.showDevOptions;
  }
}
